import React from 'react'
import {Trans} from '@lingui/macro'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency'

// Types
export type typeProductItem = {
    name: string
    amount: number
    price: number
    customTotal: number | null
    units?: string
    vat: number
    psid?: string
    barcodes?: string[]
    marked?: string
    commissionTIN?: string
    commissionPINFL?: string
    discountAmount?: number
    vatForItem?: number
}


// Component
export const CheckProductItem: React.FC<typeProductItem> = (
    {
        name,
        amount,
        price,
        customTotal,
        units,
        vat,
        psid,
        barcodes,
        marked,
        commissionTIN,
        commissionPINFL,
        discountAmount,
        vatForItem
    }
) => {
    return(
        <div className="border-b pb-1 mb-1">
            <div className="grid grid-cols-7 text-left">
                <span className="col-span-3 leading-tight text-xs font-medium">
                    {name === 'ServicePayment' ? <Trans>Service payment</Trans> : name}
                </span>
                <div className="col-span-2 flex flex-col items-center text-xs">
                    <span>
                        {amount ? numberCurrencyFormat(+amount.toFixed(3)) : ' - '} &times; {price ? numberCurrencyFormat(+price.toFixed(2)) : ' - '}
                    </span>
                    <span>
                        {units ? units : ' - '}
                    </span>
                </div>
                <span className="col-span-2 text-right text-xs font-medium">{customTotal? numberCurrencyFormat(customTotal) : numberCurrencyFormat(+(amount * price).toFixed(2)) }</span>
            </div>
            {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <> { vat
                ? <div className="flex justify-between text-xs">
                    <span><Trans>VAT including</Trans> ({ (vat * 100).toFixed(2) }%)</span>
                    <span>{ vatForItem ? numberCurrencyFormat(vatForItem) : numberCurrencyFormat(+(  (((customTotal? customTotal : price) * vat)/(1 + vat) )* amount).toFixed(2)) }</span>
                </div>
                : <div className="flex justify-between text-xs">
                    <span><Trans>VAT including</Trans></span>
                    <span>{ ( 0 ).toFixed(2) }</span>
                </div>
            }</> }
            {psid
                ? <div className="flex justify-between text-xxs">
                    <span><Trans>MXIK</Trans></span>
                    <span>{psid}</span>
                </div>
                : null
            }
            {barcodes?.length
                ? <div className="flex justify-between text-xxs">
                    <span><Trans>Barcodes</Trans></span>
                    <span>{barcodes.join(' ,')}</span>
                </div>
                : null
            }
            {marked
                ? <div className="flex justify-between text-xxs">
                    <span><Trans>Mark</Trans></span>
                    <span>{marked}</span>
                </div>
                : null
            }
            {commissionTIN
                ? <div className="flex justify-between text-xxs">
                    <span><Trans>Commission TIN</Trans></span>
                    <span>{commissionTIN}</span>
                </div>
                : null
            }
            {commissionPINFL
                ? <div className="flex justify-between text-xxs">
                    <span><Trans>Commission PINFL</Trans></span>
                    <span>{commissionPINFL}</span>
                </div>
                : null
            }
        </div>
    )
}
